import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles(theme => ({
  item: {
    borderTop: 'solid 1px #e1e1ff',
  },
  grid: {
    color: "#777766"
  }
}));

export default function CommentCard(props) {
  const classes = useStyles();

  return (
    <ListItem className={classes.item}>
      <ListItemText
        primary={
          <div>
            <Grid container justify="space-between">
              <Typography align='left' variant='body2' color="textSecondary">
                {props.index}. {(props.reply != 0) && `>> ${props.reply}.`}
              </Typography>
              <Typography align='right' variant='body2' color="textSecondary">
                {props.creator} : {props.date}
              </Typography>
            </Grid>
            <Typography variant='body1'>
              {props.text}
            </Typography>
          </div>
        }
      />
    </ListItem>
  );
}
